import { styled, css, Box } from '@mui/material'

export const ItemUnitDescription = styled('div')(
  () => css`
    font-size: 10px;
  `
)

export const SummaryItemContainer = styled(Box)(
  () => css`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d9d9d9;
    gap: 8px;
    padding: 12px 0;
  `
)

export const ColumnHeader = styled(Box)(
  () => css`
    display: flex;
    font-size: 11px;
    font-weight: 500;
  `
)
